module.exports = __webpack_public_path__ + "static/img/slide_4_pic.9faa908.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcimages/slide_4_pic.png
// module id = g5i6
// module chunks = 51